
import { ISanPhamImportRequest } from "../../../model/request/san-pham/ISanPhamImportRequest"
import { ISanPhamChiTiet } from "../../../model/respone/san-pham/ISanPhamChiTiet"
import { ISanPhamChiTietViewModel } from "../../../model/respone/san-pham/ISanPhamChiTietViewModel"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eSanPhamChiTietActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ISanPhamChiTietViewModel[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | ISanPhamChiTiet,
    CLOSE_EDIT_MODAL: undefined,
    
    SAVE_START: {} as ISanPhamChiTiet,
    SAVE_SUCCESS: {} as ISanPhamChiTiet,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
    
    SHOW_IMPORT_CHITIET_MODAL: undefined,
    CLOSE_IMPORT_CHITIET_MODAL: undefined,

    SAVE_IMPORT_CHITIET_START: {} as ISanPhamImportRequest,
    SAVE_IMPORT_CHITIET_SUCCESS: {} as ISanPhamChiTietViewModel[],
    SAVE_IMPORT_CHITIET_ERROR: "",


}
export const eSanPhamChiTietActionTypeIds = generateActionTypeIds(eSanPhamChiTietActionTypeDefine, "SAN_PHAM_CHI_TIET")

export type ISanPhamChiTietActions = IGenericActionType<typeof eSanPhamChiTietActionTypeDefine, "SAN_PHAM_CHI_TIET">